import { render } from "./OverallLogsList.vue?vue&type=template&id=406cd364&scoped=true"
import script from "./OverallLogsList.vue?vue&type=script&lang=js"
export * from "./OverallLogsList.vue?vue&type=script&lang=js"

import "./OverallLogsList.vue?vue&type=style&index=0&id=406cd364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406cd364"]])

export default __exports__